export const disableRules = [
  'blockquote',
  'list',
  'image',
  'table',
  'code',
  'hr',
  'backticks',
  'fence',
  'reference',
  'heading',
  'lheading',
  'html_block',
];
